import request from '@/utils/request2';
export function orderList(data) {
  return request.post('admin/order/list', data);
}
export function downloadOrder(data) {
  return request.post('admin/order/download', data);
}
export function orderDetail(data) {
  return request.post('admin/order/detail', data);
}
export function getTags(data) {
  return request.post('admin/order/getTags', data);
}